export default function getSectionKeys(mainSections) {
  return mainSections.reduce((res, { _key, sections }) => [
    ...res,
    _key,
    ...(sections || []).map(({ _key }) => _key),
  ], [])
}
